import { Component } from '@angular/core';

@Component({
  selector: 'app-pr3',
  templateUrl: './pr3.component.html',
  styleUrls: ['./pr3.component.scss']
})
export class Pr3Component {
  // Add any component logic here
}